import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMap = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMap.dimensions.width} ${IconMap.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M22 8.307c0 1.495-.005 2.992 0 4.488.004 1.064-.476 1.866-1.44 2.296-1.99.887-4.002 1.728-6.023 2.543-.267.107-.685.03-.966-.102a153.226 153.226 0 0 1-5.068-2.494c-.499-.258-.894-.25-1.389-.024a86.093 86.093 0 0 1-3.423 1.447c-1.934.783-3.679-.365-3.683-2.418C.003 11.124.02 8.205 0 5.288c-.009-1.229.562-2.05 1.674-2.527 1.89-.81 3.78-1.62 5.691-2.377.312-.124.786-.07 1.1.077 1.708.796 3.399 1.626 5.07 2.49.475.246.857.231 1.323.022a114.25 114.25 0 0 1 3.422-1.451c1.975-.808 3.712.337 3.718 2.443.005 1.447 0 2.894 0 4.34l.002.002ZM7.34 1.592c-.122 0-.204-.022-.264.003-1.713.719-3.428 1.435-5.135 2.17-.638.274-.923.8-.925 1.47-.004 2.969-.024 5.936.01 8.903.013 1.256 1.055 1.879 2.243 1.397 1.17-.475 2.322-.998 3.5-1.457.438-.17.59-.394.583-.861-.028-1.937-.012-3.875-.012-5.814V1.591v.001ZM14.664 16.5c1.915-.812 3.697-1.553 5.464-2.325.605-.265.86-.796.862-1.435.004-2.969.024-5.936-.01-8.905-.013-1.255-1.055-1.88-2.24-1.4-1.17.476-2.322 1-3.5 1.46-.434.17-.597.386-.588.857.032 1.668.012 3.335.012 5.004V16.5ZM8.384 1.537c0 4.066-.003 7.983.007 11.9 0 .169.07.43.191.49 1.643.838 3.303 1.648 5.04 2.505 0-4.06.003-7.998-.012-11.937 0-.174-.137-.433-.285-.51-1.603-.815-3.22-1.602-4.94-2.45l-.001.002Z"
      />
    </Svg>
  )
}

IconMap.dimensions = {
  width: 22,
  height: 18,
}

export default IconMap
